const empty = (len = 4) => {
  let arr = new Array(len).fill('\xa0')
  return arr.join('')
}
const empty6 = empty(6)
const empty12 = empty(12)
const emptyTitle = empty(4)
const contractWord = [
  {
    title: '',
    word:
      '欢迎您使用梅赛德斯-奔驰客户服务官方微信焕新优惠功能（以下简称“本功能“）！为了使用本功能，请先仔细阅读、理解并接受Mercedes me ID （梅赛德斯-奔驰账户）及梅赛德斯-奔驰平台隐私政策。您一旦使用本功能服务，即视为您已阅读并同意该隐私政策。本用户服务协议（“本协议”）由用户（“用户”）与北京梅赛德斯-奔驰销售服务有限公司（以下简称“梅赛德斯-奔驰公司或奔驰”）订立，并适用于服务中提供的所有基于互联网和移动互联网的相关服务（以下简称“网络服务”）。'
  },
  {
    title: `第一条${emptyTitle}本协议的说明`,
    word: [
      `（一）本服务的交易仅限于使用本平台和服务的用户。用户在使用本平台和服务后，即表示用户完全接受本协议项下的全部条款，本协议即构成对梅赛德斯-奔驰公司及用户双方之间具有法律约束力的正式文件。`,
      `（二）用户在使用本平台所提供的网络服务前有义务仔细阅读本协议。用户在此不可撤销地承诺，若其使用本平台中提供的网络服务，将视为用户同意并接受本协议全部条款的约束。`,
      `（三）根据国家法律法规变化及平台的运营需求，梅赛德斯-奔驰公司可随时修改本协议的任何条款，并不定期更新服务规则。`,
      `（四）本平台仅面向中国大陆境内居民，因此本平台中的所有信息仅服务于中国大陆市场。`
    ]
  },
  {
    title: `第二条${emptyTitle}商品信息`,
    word: [
      `用户明确知悉并同意，本平台中的商品信息随时有可能发生变动，梅赛德斯-奔驰公司可对此不作特别通知。梅赛德斯-奔驰公司将尽可能准确、详尽、完整的展示本平台中的商品参数、说明等商品信息，但本平台的商品信息可能会有一定的滞后性或误差，商品信息以经销商确认为准，用户对此情形已充分知悉并完全理解。`,
      `本平台中显示的金额为厂商建议零售价或经销商自行维护的商品及服务的销售价格（以金额对应说明为准）。用户对此情形已充分知悉，并将完全理解。`
    ]
  },
  {
    title: `第三条${emptyTitle}知识产权声明`,
    word: [
      '（一）奔驰提供的网络服务中包含的全部信息（包括但不限于任何文本、图片、音频、视频、数据、标识、数据编辑、商标等）以及为提供服务而使用的任何软件等均受知识产权和相关法律保护。未经奔驰的事先书面同意，用户不得以任何方式复制、转发、分享或以其他方式使用奔驰提供的网络服务中包含的任何信息，否则，奔驰将依法追究其法律责任。用户以个人和非商业目的使用奔驰的网络服务的情况除外。',
      '（二）任何单位或个人认为奔驰提供的网络服务中包含的信息涉嫌侵犯其合法权益的，应该及时向奔驰提出书面权利通知，并提供身份证明、权属证明、具体链接（URL）及详细侵权情况证明等必要证明资料。奔驰在确认上述法律文件的基础上将会依法尽快处理。'
    ]
  }
]

const planContractWord = [
  {
    title: '',
    word:
      '欢迎您使用梅赛德斯-奔驰客户服务官方微信【梅赛德斯-奔驰致友计划线上订购】功能（以下简称“本功能”）！为了使用本功能，请先仔细阅读、理解并接受Mercedes me ID （梅赛德斯-奔驰账户）及梅赛德斯-奔驰平台服务协议以及平台服务隐私政策。在您确认阅读并同意该平台服务协议及隐私政策的情况下，您一旦使用本功能服务，即视为您已阅读并同意本功能用户服务协议。本用户服务协议（“本协议”）由用户（“用户”）与梅赛德斯-奔驰（中国）汽车销售有限公司（以下简称“梅赛德斯-奔驰公司或奔驰”）订立，并适用于服务中提供的所有基于互联网和移动互联网的相关服务（以下简称“网络服务”）。'
  },
  {
    title: `第一条${emptyTitle}商品订购`,
    word: [
      '本功能中的商品为【梅赛德斯-奔驰致友计划】，其所涉服务由用户选定的经销商向用户提供，并由用户与该经销商签订相应合同。',
      '1.通过“选择车辆”购买【梅赛德斯-奔驰致友计划】，选定经销商并输入车辆信息完成车辆绑定，进行线上支付“全款”金额；',
      '2.通过“暂不选择车辆”购买【梅赛德斯-奔驰致友计划】，选定经销商支付“意向金”，您的意向金将支付至您所选择经销商的【银联商务】托管账户，【银联商务】为梅赛德斯-奔驰官方平台在线购车及售后服务产品的支付服务方。若您与经销商签署了购买合约，您的意向金将自动转给经销商，并相应抵扣您与经销商商定的购买价格。（*仅部分车型参与【梅赛德斯-奔驰致友计划】活动，详情请咨询购买经销商）'
    ]
  },
  {
    title: `第二条${emptyTitle}商品激活`,
    word: [
      `1.若您通过“全款”购买【梅赛德斯-奔驰致友计划】将由您所选择的经销商接受订单时自动激活。`,
      `2.若您通过“意向金”购买【梅赛德斯-奔驰致友计划】，意向金仅代表您的初步购买意向，不具有担保性质。意向金支付完成后，请及时联系您所选择的经销商，预约进店完成经销商要求的流程后，由经销商激活。`,
      `*商品激活意味着权益生效，您可实际使用。`
    ]
  },
  {
    title: `第三条${emptyTitle}商品退订`,
    word: [
      '您有权退订您尚在合同有效期内且未使用的权益。',
      '1.若您“全款”所购买的订单未激活，可以在订单中点击“申请退款”，经销商点击“同意退款”，您的订单实付金额会在24小时内全额原路退回您的支付账户。若经销商未点击“同意退款”，您的订单将在24小时后自动同意退款，订单实付金额立即全额原路退回您的支付账户。',
      '2.您支付“意向金”后如点击“申请退款”经销商点击“同意退款”，您的意向金会在24小时内全额原路退回您的支付账户。若经销商未点击“同意退款”，您的意向金订单将在24小时后自动同意退款，意向金立即全额原路退回您的支付账户。',
      '*若您所购买的订单已激活，请恕无法申请线上退款，您可联系购买时所选经销商办理线下退款手续，经销商联系方式可在订单中查询。'
    ]
  }
]
const tyreContractWord = [
  {
    title: '',
    word:
      '欢迎您使用梅赛德斯-奔驰客户服务套餐（致友计划，轮胎畅享礼包及其他不时上市的服务套餐）线上订购功能（以下简称“本功能“）！为了使用本功能，请先仔细阅读、理解并接受Mercedes me ID （梅赛德斯-奔驰账户）及梅赛德斯-奔驰平台服务协议以及平台服务隐私政策。在您确认阅读并同意该平台服务协议及隐私政策的情况下，您一旦使用本功能服务，即视为您已阅读并同意本功能用户服务协议。本用户服务协议（“本协议”）由用户（“用户”）与梅赛德斯-奔驰（中国）汽车销售有限公司（以下简称“梅赛德斯-奔驰公司或奔驰”）订立，并适用于服务中提供的所有基于互联网和移动互联网的相关服务（以下简称“网络服务”）。'
  },
  {
    title: `第一条${emptyTitle}商品订购`,
    word: [
      '本功能中的商品为梅赛德斯-奔驰客户服务套餐，其所涉服务由用户选定的经销商向用户提供，用户订购并支付订单即视为与该经销商达成服务合同。（*仅部分车型参与梅赛德斯-奔驰客户服务套餐活动，详情请咨询购买经销商）',
    ]
  },
  {
    title: `第二条${emptyTitle}商品生效`,
    word: [
      `您所购买的梅赛德斯-奔驰客户服务套餐，将自订单中对应权益的生效日期生效。关于生效日期的说明请参见卡券权益描述和限制说明。`,
    ]
  },
  {
    title: `第三条${emptyTitle}商品退订`,
    word: [
      '您有权退订您尚在合同有效期内且未使用的梅赛德斯-奔驰客户服务套餐商品。',
      '若您所购买的商品订单未激活(您所购买的商品在您购买时选择的经销商接受订单时激活)，可以在订单中点击“申请退款”，经销商点击“同意退款”，您的订单实付金额会在24小时内全额原路退回您的支付账户。若经销商未点击“同意退款”，您的订单将在24小时后自动同意退款，订单实付金额立即全额原路退回您的支付账户。',
      '*若您所购买的订单已激活，请恕无法申请线上退款，您可联系购买时所选经销商办理线下退款手续，经销商联系方式可在订单中查询。'
    ]
  }
]
let planWordContent = planContractWord.map(item => {
  const title = item.title || ''
  let word = []
  if (typeof item.word === 'string') {
    word.push({ empty: empty6, content: item.word })
  } else if (Array.isArray(item.word)) {
    let wordTemp = []
    for (let index = 0; index < item.word.length; index++) {
      let wordItem = item.word[index]
      if (typeof wordItem === 'string') {
        wordTemp.push({ empty: empty6, content: wordItem })
      } else if (Array.isArray(wordItem)) {
        for (let j = 0; j < wordItem.length; j++) {
          if (typeof wordItem[j] === 'string') {
            wordTemp.push({ empty: empty12, dot: true, content: wordItem[j] })
          }
        }
      } else {
        wordItem && wordTemp.push(wordItem)
      }
    }
    word = wordTemp
  }
  return { title, word }
})
let wordContent = contractWord.map(item => {
  const title = item.title || ''
  let word = []
  if (typeof item.word === 'string') {
    word.push({ empty: empty6, content: item.word })
  } else if (Array.isArray(item.word)) {
    let wordTemp = []
    for (let index = 0; index < item.word.length; index++) {
      let wordItem = item.word[index]
      if (typeof wordItem === 'string') {
        wordTemp.push({ empty: empty6, content: wordItem })
      } else if (Array.isArray(wordItem)) {
        for (let j = 0; j < wordItem.length; j++) {
          if (typeof wordItem[j] === 'string') {
            wordTemp.push({ empty: empty12, dot: true, content: wordItem[j] })
          }
        }
      } else {
        wordItem && wordTemp.push(wordItem)
      }
    }
    word = wordTemp
  }
  return { title, word }
})
let tyreContent = tyreContractWord.map(item => {
  const title = item.title || ''
  let word = []
  if (typeof item.word === 'string') {
    word.push({ empty: empty6, content: item.word })
  } else if (Array.isArray(item.word)) {
    let wordTemp = []
    for (let index = 0; index < item.word.length; index++) {
      let wordItem = item.word[index]
      if (typeof wordItem === 'string') {
        wordTemp.push({ empty: empty6, content: wordItem })
      } else if (Array.isArray(wordItem)) {
        for (let j = 0; j < wordItem.length; j++) {
          if (typeof wordItem[j] === 'string') {
            wordTemp.push({ empty: empty12, dot: true, content: wordItem[j] })
          }
        }
      } else {
        wordItem && wordTemp.push(wordItem)
      }
    }
    word = wordTemp
  }
  return { title, word }
})
// console.log('wordContent-->', wordContent)
let contractData = {
  title: '用户服务协议',
  contents: wordContent
}
let planContractData = {
  title: '用户服务协议',
  contents: tyreContent
}
let tyreContractData = {
  title: '用户服务协议',
  contents: tyreContent
}
export { contractData, planContractData, tyreContractData }
